class Elementor_Give_Campain_Feature {
    static instance;

    static getInstance() {
        if (!Elementor_Give_Campain_Feature.instance) {
            Elementor_Give_Campain_Feature.instance = new Elementor_Give_Campain_Feature();
        }
        return Elementor_Give_Campain_Feature.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-give-campain-feature.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }
        });
    }
}

Elementor_Give_Campain_Feature.getInstance();